var Ask = require('./ask');
var Traffic = require('./trafficAccident');
var Work = require('./workAccident');
module.exports = san.defineComponent({
        template: require('../views/app.html'),
        initData: function() {
            return {
                listType: 1,
                type: '',
                askAnLi: '',
                showLoading: false,
                cortShow: false,
                showFlag: true,
                businessType: -1
            };
        },
        components: {
            'ask': Ask,
            'traffic': Traffic,
            'work': Work
        },
        created: function() {
            localStorage.sysUserId = 'unknown00008';
            this.businessType = null;
            var me=this;
            setTimeout(function(){
                $.ajax({
                    url: "/static/bgImage.json",
                    dataType : 'json',
                    success: function(resp){
                        resp.forEach(function (item) {
                            if(item.domain==document.domain){
                                $('.bgsy').addClass(item.img);
                                san.nextTick(function () {
                                    me.data.set('type', item.type);
                                })
                            }
                        })
                    },
                    error: function(err) {
                        console.log(err.msg);
                    }
                });
                Api("post","/api/wechatAutor/saveAnonymousUserInfo").then(function(response){
                    if (response) {
                        localStorage.sysUserId = response.user.userId;
                    }
                });
                if(!!sessionStorage.safeInfo){
                    me.ref('ask').init();
                }else{
                    $.ajax({
                        url: '/api/websafe/safeInfo?domainName='+document.domain,
                        type: 'get',
                        dataType : 'json',
                        contentType: 'application/json',
                        data: null,
                        success: function(response){
                            sessionStorage.safeInfo = response.safeInfo;
                            me.ref('ask').init();
                        },
                        error: function(err) {

                        }
                    });
                }

            },0);
        },
        switchType: function(t) {
            this.data.set('businessType' , t);
            var me=this;
            san.nextTick(function () {
                (t==20 || t==11)?me.data.set('listType' , 2):me.data.set('listType' , 1);
                (t<10 || t==485)?me.ref('ask').initType(t,2):'';
                if(t==20){
                    me.data.set('showLoading', true);
                    document.getElementById('myIframe').onload = function () {
                        me.data.set('showLoading', false);
                    }
                }
            });
        },
        okFun: function(){
            this.data.set('showFlag',false);
        },
        goBack: function(){
                if(this.businessType==null){
                    this.data.set('businessType', -1);
                }else{
                    this.data.set('businessType', this.businessType);
                }
        },
        messages:{
            switchChild: function(str){
                this.data.set('businessType', str.value);
            },
            qjzxanswer2: function(caseId){
                this.businessType = this.data.get('businessType');
                this.data.set('businessType', 0);
                this.data.set('showLoading', true);
                var me = this;
                if(caseId.value){
                    Api("get","/api/lawyer/v2/getdoc/" + caseId.value, null).then(function(response){
                        me.data.set('showLoading', false);
                        if (response) {
                            me.data.set('askAnLi',response.content);
                        }
                    });
                }
            },
            accident: function(n){
                this.data.set('listType', 2);
                this.data.set('businessType', n.value);
            }
        }
});




//////////////////
// WEBPACK FOOTER
// ./src/components/app.js
// module id = 346
// module chunks = 1